export function normalizeValue(value) {
  return String(value || '').trim().toLowerCase();
}

export function resolveScanStatusValue(value) {
  const normalized = normalizeValue(value);

  if (normalized === '1') {
    return 'uploaded';
  }

  if (normalized === '2') {
    return 'scanning';
  }

  if (normalized === '3') {
    return 'clean';
  }

  if (normalized === '4') {
    return 'quarantined';
  }

  if (normalized === '5') {
    return 'failed';
  }

  return normalized;
}

export function resolveCaseStatusValue(value) {
  const normalized = normalizeValue(value);

  if (normalized === '1') {
    return 'active';
  }

  if (normalized === '2') {
    return 'archived';
  }

  if (normalized === '3') {
    return 'retrieved';
  }

  if (normalized === '4') {
    return 'archiving';
  }

  if (normalized === '5') {
    return 'retrieving';
  }

  return normalized;
}

export function resolveMediaRecordStatusValue(value) {
  const normalized = normalizeValue(value);

  if (normalized === '1') {
    return 'draft';
  }

  if (normalized === '2') {
    return 'submitted';
  }

  if (normalized === '3') {
    return 'deleted';
  }

  if (normalized === '4') {
    return 'unsubmitted';
  }

  if (normalized === '5') {
    return 'archived';
  }

  if (normalized === '6') {
    return 'retrieved';
  }

  return normalized;
}
